import { render, staticRenderFns } from "./CustomerComplaintApproval.vue?vue&type=template&id=44766aa6&"
import script from "./CustomerComplaintApproval.vue?vue&type=script&lang=js&"
export * from "./CustomerComplaintApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports